// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root, body, #root, #app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#root {
  margin: 0;
  padding: 0;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  background-color: var(--theme-main-background-color);
  color: var(--theme-primary-text-color);
}

input, button, textarea, select {
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  background-color: transparent;
  border: none;
  outline: none;
  appearance: none;
  border-radius: unset;
}

#app {
  display: grid;
  grid-template-rows: [app-start top-bar-start] 3rem [top-bar-end main-start] 1fr [main-end app-end];
  transition: ease-in-out 0.3s grid-template-columns;
}

#app.app-drawer-closed {
  grid-template-columns: [app-start main-start drawer-start] 0 [drawer-end] 1fr [main-end app-end];
}

#app.app-drawer-open {
  grid-template-columns: [app-start main-start drawer-start] var(--drawer-width) [drawer-end] 1fr [main-end app-end];
}

#app-top-bar {
  grid-row: top-bar-start / top-bar-end;
  grid-column: app-start / app-end;
  background-color: var(--theme-accent-text-color);
  color: var(--theme-accent-color);
  display: flex;
  align-items: center;
  flex-direction: row;
}

#app-top-bar-main {
  flex-shrink: 1;
  inline-size: auto;
  display: flex;
  align-items: center;
  flex-direction: row;
  min-inline-size: 0;
  overflow: hidden;
}

#app-top-bar-side {
  flex-shrink: 1;
  flex-grow: 1;
  min-inline-size: 0;
  display: flex;
  align-items: center;
  flex-direction: row;
  transition: inline-size 0.3s ease-in-out;
}

#app-top-bar-branding {
  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: row;
  box-sizing: border-box;
  min-inline-size: 0;
  flex: 1;
}

#app-top-bar-branding-logo {
  display: block;
  max-block-size: 2.5rem;
  max-inline-size: 12rem;
  margin-inline-end: .5rem;
}

#app-top-bar-branding-title {
  font-weight: bold;
  font-size: 1.25rem;
}

#app-top-bar-navigation {
  display: flex;
  flex: 1;
  flex-direction: row;
  block-size: 2.5rem;
  margin-block-start: .5rem;
  align-items: stretch;
}

.app-top-bar-navigation-start-edge, .app-top-bar-navigation-end-edge {
  fill: var(--theme-secondary-accent-color);
  flex-shrink: 0;
}

:dir(rtl) :is(.app-top-bar-navigation-start-edge, .app-top-bar-navigation-end-edge) {
  transform: scaleX(-1);
}

.app-top-bar-navigation-content {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: var(--theme-highlight-background-color);
  color: var(--theme-accent-color);
  column-gap: .5rem;
}

#app-overlay {
  grid-row: app-start / app-end;
  grid-column: drawer-end / main-end;
  background-color: var(--theme-overlay-color);
  opacity: 1;
  transition: ease-in-out 0.3s opacity, ease-in-out 0.3s visibility;
}

#app.app-drawer-closed #app-overlay {
  visibility: hidden;
  opacity: 0;
  transition: ease-in-out 0.3s opacity, ease-in-out 0s 0.3s visibility;
}

#app-main {
  grid-row: main-start / main-end;
  grid-column: main-start / main-end;
  overflow: auto;
  display: flex;
  flex-direction: column;
  border-block-start: solid var(--theme-accent-color) .125rem;
}

#app-main-inner {
  inline-size: calc(100% - 1rem);
  box-sizing: border-box;
  border-radius: .5rem;
  margin: .5rem;
  max-inline-size: 40rem;
  background-color: var(--theme-highlight-background-color);
  padding-inline: .5rem;
}

#app-drawer {
  grid-row: main-start / main-end;
  grid-column: drawer-start / drawer-end;
  background-color: var(--theme-highlight-background-color);
  color: var(--theme-secondary-text-color);
  overflow: hidden;
  opacity: 1;
  display: flex;
  flex-direction: row;
}

#app.app-drawer-closed #app-drawer {
  visibility: hidden;
  transition: ease-in-out 0s 0.3s visibility;
}

#app #app-drawer-navigation > * {
  opacity: 1;
  transition: ease-in-out 0.1s 0.2s opacity;
}

#app.app-drawer-closed #app-drawer-navigation > * {
  opacity: 0;
  transition: none;
}

#app-drawer > #app-drawer-shortcuts {
  inline-size: 4rem;
  min-inline-size: 0;
  overflow-inline: hidden;
  overflow-block: auto;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  align-items: center;
  padding-block: 1rem;
}

#app-drawer > #app-drawer-navigation {
  background-color: var(--theme-secondary-accent-color);
  color: var(--theme-secondary-text-color);
  flex: 1;
  min-inline-size: 0;
  overflow-inline: hidden;
  overflow-block: auto;
  border-block-start: solid var(--theme-accent-color) .125rem;
  border-inline-start: solid var(--theme-accent-color) .125rem;
  border-start-start-radius: 1rem;
}

#app-drawer-heading {
  margin: 0;
  padding-block-start: 1rem;
  padding-block-end: .5rem;
  padding-inline: 1rem;
  font-weight: bold;
  font-size: 150%;
}

@media (min-width: 40rem) {
  #app-overlay {
    display: none !important;
  }

  #app.app-drawer-closed {
    grid-template-columns: [app-start drawer-start] 0 [drawer-end main-start] 1fr [main-end app-end];
  }

  #app.app-drawer-open {
    grid-template-columns: [app-start drawer-start] var(--drawer-width) [drawer-end main-start] 1fr [main-end app-end];
  }
}

@media print {
  #app {
    grid-template-columns: [app-start main-start drawer-start] 0 [drawer-end] 1fr [main-end app-end] !important;
  }

  #root {
    background-color: unset !important;
  }

  .app-drawer-toggle-button {
    display: none !important;
  }
}

.app-button {
  appearance: none;
  margin: 0;
  padding: 0;
  font-size: 1.5rem;
  background-color: transparent;
  color: inherit;
  border: none;
  inline-size: 3rem;
  block-size: 3rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-button:hover {
  opacity: .75;
}

.app-drawer-toggle-button {
  inline-size: 4rem;
  color: var(--theme-secondary-text-color);
}

.app-shortcut-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--theme-secondary-text-color);
  text-decoration: none;
  padding: .5rem;
  border-radius: .5rem;
  cursor: default;
}

.app-shortcut-item.selected {
  background-color: var(--theme-selected-color);
}

.app-shortcut-item > .icon {
  font-size: 200%;
}

.app-shortcut-item > .text {
  font-size: 80%;
}

.c-ScrollBox-outer {
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.c-ScrollBox-inner {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.c-ScrollBox-origin-start {
  justify-content: start;
}

.c-ScrollBox-origin-end {
  justify-content: end;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,mJAAmJ;EACnJ,oDAAoD;EACpD,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kGAAkG;EAClG,kDAAkD;AACpD;;AAEA;EACE,gGAAgG;AAClG;;AAEA;EACE,kHAAkH;AACpH;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,gDAAgD;EAChD,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,yDAAyD;EACzD,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,4CAA4C;EAC5C,UAAU;EACV,iEAAiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oEAAoE;AACtE;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,2DAA2D;AAC7D;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,yDAAyD;EACzD,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;EACtC,yDAAyD;EACzD,wCAAwC;EACxC,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,wCAAwC;EACxC,OAAO;EACP,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,2DAA2D;EAC3D,4DAA4D;EAC5D,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,gGAAgG;EAClG;;EAEA;IACE,kHAAkH;EACpH;AACF;;AAEA;EACE;IACE,2GAA2G;EAC7G;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":["\n:root, body, #root, #app {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n#root {\n  margin: 0;\n  padding: 0;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  background-color: var(--theme-main-background-color);\n  color: var(--theme-primary-text-color);\n}\n\ninput, button, textarea, select {\n  font-family: inherit;\n  font-size: inherit;\n  color: inherit;\n  background-color: transparent;\n  border: none;\n  outline: none;\n  appearance: none;\n  border-radius: unset;\n}\n\n#app {\n  display: grid;\n  grid-template-rows: [app-start top-bar-start] 3rem [top-bar-end main-start] 1fr [main-end app-end];\n  transition: ease-in-out 0.3s grid-template-columns;\n}\n\n#app.app-drawer-closed {\n  grid-template-columns: [app-start main-start drawer-start] 0 [drawer-end] 1fr [main-end app-end];\n}\n\n#app.app-drawer-open {\n  grid-template-columns: [app-start main-start drawer-start] var(--drawer-width) [drawer-end] 1fr [main-end app-end];\n}\n\n#app-top-bar {\n  grid-row: top-bar-start / top-bar-end;\n  grid-column: app-start / app-end;\n  background-color: var(--theme-accent-text-color);\n  color: var(--theme-accent-color);\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n}\n\n#app-top-bar-main {\n  flex-shrink: 1;\n  inline-size: auto;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  min-inline-size: 0;\n  overflow: hidden;\n}\n\n#app-top-bar-side {\n  flex-shrink: 1;\n  flex-grow: 1;\n  min-inline-size: 0;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  transition: inline-size 0.3s ease-in-out;\n}\n\n#app-top-bar-branding {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  flex-direction: row;\n  box-sizing: border-box;\n  min-inline-size: 0;\n  flex: 1;\n}\n\n#app-top-bar-branding-logo {\n  display: block;\n  max-block-size: 2.5rem;\n  max-inline-size: 12rem;\n  margin-inline-end: .5rem;\n}\n\n#app-top-bar-branding-title {\n  font-weight: bold;\n  font-size: 1.25rem;\n}\n\n#app-top-bar-navigation {\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  block-size: 2.5rem;\n  margin-block-start: .5rem;\n  align-items: stretch;\n}\n\n.app-top-bar-navigation-start-edge, .app-top-bar-navigation-end-edge {\n  fill: var(--theme-secondary-accent-color);\n  flex-shrink: 0;\n}\n\n:dir(rtl) :is(.app-top-bar-navigation-start-edge, .app-top-bar-navigation-end-edge) {\n  transform: scaleX(-1);\n}\n\n.app-top-bar-navigation-content {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--theme-highlight-background-color);\n  color: var(--theme-accent-color);\n  column-gap: .5rem;\n}\n\n#app-overlay {\n  grid-row: app-start / app-end;\n  grid-column: drawer-end / main-end;\n  background-color: var(--theme-overlay-color);\n  opacity: 1;\n  transition: ease-in-out 0.3s opacity, ease-in-out 0.3s visibility;\n}\n\n#app.app-drawer-closed #app-overlay {\n  visibility: hidden;\n  opacity: 0;\n  transition: ease-in-out 0.3s opacity, ease-in-out 0s 0.3s visibility;\n}\n\n#app-main {\n  grid-row: main-start / main-end;\n  grid-column: main-start / main-end;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  border-block-start: solid var(--theme-accent-color) .125rem;\n}\n\n#app-main-inner {\n  inline-size: calc(100% - 1rem);\n  box-sizing: border-box;\n  border-radius: .5rem;\n  margin: .5rem;\n  max-inline-size: 40rem;\n  background-color: var(--theme-highlight-background-color);\n  padding-inline: .5rem;\n}\n\n#app-drawer {\n  grid-row: main-start / main-end;\n  grid-column: drawer-start / drawer-end;\n  background-color: var(--theme-highlight-background-color);\n  color: var(--theme-secondary-text-color);\n  overflow: hidden;\n  opacity: 1;\n  display: flex;\n  flex-direction: row;\n}\n\n#app.app-drawer-closed #app-drawer {\n  visibility: hidden;\n  transition: ease-in-out 0s 0.3s visibility;\n}\n\n#app #app-drawer-navigation > * {\n  opacity: 1;\n  transition: ease-in-out 0.1s 0.2s opacity;\n}\n\n#app.app-drawer-closed #app-drawer-navigation > * {\n  opacity: 0;\n  transition: none;\n}\n\n#app-drawer > #app-drawer-shortcuts {\n  inline-size: 4rem;\n  min-inline-size: 0;\n  overflow-inline: hidden;\n  overflow-block: auto;\n  display: flex;\n  flex-direction: column;\n  row-gap: 1rem;\n  align-items: center;\n  padding-block: 1rem;\n}\n\n#app-drawer > #app-drawer-navigation {\n  background-color: var(--theme-secondary-accent-color);\n  color: var(--theme-secondary-text-color);\n  flex: 1;\n  min-inline-size: 0;\n  overflow-inline: hidden;\n  overflow-block: auto;\n  border-block-start: solid var(--theme-accent-color) .125rem;\n  border-inline-start: solid var(--theme-accent-color) .125rem;\n  border-start-start-radius: 1rem;\n}\n\n#app-drawer-heading {\n  margin: 0;\n  padding-block-start: 1rem;\n  padding-block-end: .5rem;\n  padding-inline: 1rem;\n  font-weight: bold;\n  font-size: 150%;\n}\n\n@media (min-width: 40rem) {\n  #app-overlay {\n    display: none !important;\n  }\n\n  #app.app-drawer-closed {\n    grid-template-columns: [app-start drawer-start] 0 [drawer-end main-start] 1fr [main-end app-end];\n  }\n\n  #app.app-drawer-open {\n    grid-template-columns: [app-start drawer-start] var(--drawer-width) [drawer-end main-start] 1fr [main-end app-end];\n  }\n}\n\n@media print {\n  #app {\n    grid-template-columns: [app-start main-start drawer-start] 0 [drawer-end] 1fr [main-end app-end] !important;\n  }\n\n  #root {\n    background-color: unset !important;\n  }\n\n  .app-drawer-toggle-button {\n    display: none !important;\n  }\n}\n\n.app-button {\n  appearance: none;\n  margin: 0;\n  padding: 0;\n  font-size: 1.5rem;\n  background-color: transparent;\n  color: inherit;\n  border: none;\n  inline-size: 3rem;\n  block-size: 3rem;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.app-button:hover {\n  opacity: .75;\n}\n\n.app-drawer-toggle-button {\n  inline-size: 4rem;\n  color: var(--theme-secondary-text-color);\n}\n\n.app-shortcut-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: var(--theme-secondary-text-color);\n  text-decoration: none;\n  padding: .5rem;\n  border-radius: .5rem;\n  cursor: default;\n}\n\n.app-shortcut-item.selected {\n  background-color: var(--theme-selected-color);\n}\n\n.app-shortcut-item > .icon {\n  font-size: 200%;\n}\n\n.app-shortcut-item > .text {\n  font-size: 80%;\n}\n\n.c-ScrollBox-outer {\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.c-ScrollBox-inner {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.c-ScrollBox-origin-start {\n  justify-content: start;\n}\n\n.c-ScrollBox-origin-end {\n  justify-content: end;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
